import React from 'react';
import { usePushNotifications } from '../hooks/usePushNotifications';
import PushNotificationUI from './PushNotificationUI';

const PushNotificationManager = ({ userId = 'guest' }) => {
  const API_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8001';
  
  const {
    isSubscribed,
    loading,
    message,
    subscribeToPush,
    unsubscribeFromPush
  } = usePushNotifications(userId, API_URL);

  // Don't render if notifications aren't supported
  if (!('Notification' in window) || !('serviceWorker' in navigator)) {
    return null;
  }

  return (
    <PushNotificationUI
      isSubscribed={isSubscribed}
      loading={loading}
      message={message}
      onSubscribe={subscribeToPush}
      onUnsubscribe={unsubscribeFromPush}
    />
  );
};

export default PushNotificationManager;
